function getFullBleedExperienceTextPositionClass(classes, textPosition) {
  const positionClassMap = {
    "top-middle": classes.fullBleedExperienceTopMiddle,
    "bottom-middle": classes.fullBleedExperienceBottomMiddle
  };
  return positionClassMap[textPosition];
}

export { getFullBleedExperienceTextPositionClass };
